import { ApolloError } from '@apollo/client';

const isNetworkError = (error: Error | undefined | null) =>
  error ? Boolean(error instanceof ApolloError && error.networkError) : false;

export { isNetworkError };
